import { DataSourceState } from "../../requests/dataSources/types";

export const statePLACEHOLDER: DataSourceState = {
  serverState: "unknown",
  error: "",
  timeout: false,
};
